import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'

export const SButton = styled.button`
  font-size: ${props => props.theme.typography.buttonFontSize};
  border: 2px solid ${props => props.theme.colors.accent};
  background-color: ${props => props.theme.colors.accent};
  color: ${(props) => props.theme.colors.activeButtonText};
  transition: 0.3s;
  border-radius: 50px;
  line-height: 20px;
  cursor: pointer;
  padding: 16px 20px;
  text-decoration: none;

  &:hover {
    background-color: white;
  }

  &:focus {
    outline: none;
  }
`

const Button: React.FC<HTMLAttributes<HTMLButtonElement>> = ({children, ...rest}) => {
  return <SButton {...rest}>{children}</SButton>
}

export default Button